import { Navigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import Lodash from 'lodash';


const WebApplicationRedirector = () => {
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.languageCode.payload, shallowEqual);

    if ( !Lodash.isEmpty(webApplicationLanguageCode) ) {
        return <Navigate to={`/${webApplicationLanguageCode}`} replace={true} />;
    }

    return null;
}

export default WebApplicationRedirector;
